/** @license ISC License (c) copyright 2016 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var isArray = require('./isArray')
var isFunction = require('./isFunction')
var isObject = require('./isObject')
var isString = require('./isString')

function arrayInspect(xs) {
  return xs.length
    ? xs.map(inspect).reduce(function (a, x) { return a + ',' + x; })
    : xs
}

// inspect : a -> String
function inspect(x) {
  if(x && isFunction(x.inspect)) {
    return (" " + (x.inspect()))
  }

  if(isFunction(x)) {
    return ' Function'
  }

  if(isArray(x)) {
    return (" [" + (arrayInspect(x)) + " ]")
  }

  if(isObject(x)) {
    return ' {}'
  }

  if(isString(x)) {
    return (" \"" + x + "\"")
  }

  return (" " + x)
}

module.exports = inspect



//////////////////
// WEBPACK FOOTER
// ./~/crocks/core/inspect.js
// module id = ./node_modules/crocks/core/inspect.js
// module chunks = 0